import React from 'react';
import useAddCoupon from '../state/useAddCoupon';
import { NotificationManager } from 'react-notifications';
import texts from 'features/SpilKlub/texts';

const AddCoupon = ({ poolId, refetchPoolDetails }) => {
    const { addCoupon } = useAddCoupon({ poolId });

    const onClick = () => {
        addCoupon({
            combinationCount: 0,
            combinationPrice: 0.5,
            selections: [],
        }).then(() => {
            refetchPoolDetails();
            NotificationManager.success(texts.betslip.couponAdded);
        });
    };

    return (
        <div className="add-coupon-area" onClick={onClick}>
            <div className="bold" style={{ fontSize: '14px' }}>
                + Tilføj en kupon mere
            </div>
            <div style={{ fontSize: '12px' }}>
                Du kan altid tilføje flere kuponer til en runde
            </div>
        </div>
    );
};

export default AddCoupon;
